module.exports = __webpack_public_path__ + "img/JDRF_Royal_B.a018ffc1.jpg";